import { render, staticRenderFns } from "./Software.vue?vue&type=template&id=595ae459&scoped=true&"
import script from "./Software.vue?vue&type=script&lang=ts&"
export * from "./Software.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595ae459",
  null
  
)

export default component.exports